import {
  CreateUpdateDeleteGuideTargetsRequestDto,
  GuideTargetHistoryDto,
  GuideTargetRowDto,
  GuideTargetsAvailablePeriodsDto,
  GuideTargetTypeDto,
  PaginatedGuideTargetsDto,
  RevenueTargetDto,
  ServiceAreaDto,
  UpdateRevenueTarget,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpointDefinition';

export const guideTargetsRequests = {
  getGuideTargetsAvailablePeriods: EndpointDefinition.get<
    GuideTargetsAvailablePeriodsDto,
    null
  >({
    name: 'getGuideTargetsAvailablePeriods',
    route: '/guides/guide-targets/available-periods',
  }),
  getGuideTargetTypes: EndpointDefinition.get<GuideTargetTypeDto[], null>({
    name: 'getGuideTargetTypes',
    route: '/guides/guide-targets/target-types',
  }),
  getGuideTargetsServiceAreas: EndpointDefinition.get<ServiceAreaDto[], null>({
    name: 'getGuideTargetsServiceAreas',
    route: '/guides/guide-targets/service-areas',
  }),
  getGuideTargets: EndpointDefinition.get<
    PaginatedGuideTargetsDto,
    {
      yearMo: number;
      'page-start': number;
      'page-size': number;
      'sort-by'?: string;
      'sort-direction'?: string;
      clientIds?: number[];
      guideIds?: string[];
      targetTypeKeys?: string[];
      serviceAreaKeys?: string[];
    }
  >({
    name: 'getGuideTargets',
    route: '/guides/guide-targets',
  }),
  getGuideTargetHistory: EndpointDefinition.get<
    GuideTargetHistoryDto[],
    { id: number }
  >({
    name: 'getGuideTargetHistory',
    route: '/guides/guide-targets/:id/history',
  }),
  createUpdateDeleteGuideTargets: EndpointDefinition.post<
    {
      newGuideTargets: GuideTargetRowDto[];
      updatedGuideTargets: GuideTargetRowDto[];
      deletedGuideTargets: GuideTargetRowDto[];
      yearMo: number;
    },
    CreateUpdateDeleteGuideTargetsRequestDto,
    null
  >({
    name: 'createUpdateDeleteGuideTargets',
    route: '/guides/guide-targets/create-update-delete',
  }),
  updateClientRevenue: EndpointDefinition.patch<
    RevenueTargetDto,
    UpdateRevenueTarget,
    null
  >({
    name: 'updateClientRevenue',
    route: '/guides/guide-targets/revenue-targets',
  }),
};
